import Commons from '../../../../Services/Common/Common';

/**
 * PPE_BASIC_03 (보호구 지급대장) 스키마
 * 서버 응답: PascalCase (IssuId, UserId, UserDepNm, UserRank, UserNm, EquipNm, …, IssuSignPath, IssuUserId, IssuUserNm, Remark 등)
 * 그리드 데이터: camelCase로 저장
 */
export const PPE_BASIC_03_Schema = {
  fields: {
    issuId: { initial: '', label: '지급ID' },
    /** 지급 대상(성명 선택 시 회원 id, 저장 시 ToUserId 매핑) */
    userId: { initial: '', label: '지급대상자ID' },
    userDepNm: { initial: '', label: '부서' },
    userRank: { initial: '', label: '직위' },
    userNm: { initial: '', label: '성명', required: 'Y' },
    erCd: { initial: '', label: '보호구코드' },
    equipNm: { initial: '', label: '보호구명', required: 'Y' },
    reason: { initial: '', label: '지급용도' },
    createDate: { initial: null, label: '지급일자' },
    qty: { initial: null, label: '수량', required: 'Y' },
    issuSign: { initial: '', label: '서명' },
    issuSignPath: { initial: '', label: '서명경로' },
    stockQty: { initial: 0, label: '현재 재고수량' },
    managerDepartment: { initial: '', label: '관리부서코드' },
    managerDepNmLast: { initial: '', label: '담당부서' },
    /** 지급인 선택 시 회원 id (저장 시 IssuUserId 매핑) */
    issuUserId: { initial: '', label: '지급인ID' },
    issuUserNm: { initial: '', label: '지급인', required: 'Y' },
    remark: { initial: '', label: '비고' },
  },

  mapper: {
    // 지급대장 조회
    search1: {
      Year: (_, context) => {
        const year = context.search?.currentYear || context.year || '';
        return Commons.EncryptAES(String(year)) || '';
      },
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
    },
    // 보호구 등록 조회
    search2: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
    },
    /** 근로자별 보호구 저장 SaveEicBasicU1 (SP_EQUIP_ISSUE_U1) */
    save1: {
      IssuId: (row) => {
        console.log(row);
        return Commons.EncryptAES(row.issuId?.toString() ?? '') || '';
      },
      ErCd: (row) => Commons.EncryptAES(row.erCd?.toString() ?? '') || '',
      CustCd: (row) => Commons.EncryptAES(row.custCd ?? '') || '',
      ToUserId: (row) => Commons.EncryptAES(row.userId ?? '') || '',
      Qty: (row) => Commons.EncryptAES(String(row.qty) ?? '') || '',
      Reason: (row) => Commons.EncryptAES(row.reason ?? '') || '',
      IssuSign: (row) => Commons.EncryptAES('N') || '',
      IssuSignPath: (row) => Commons.EncryptAES('') || '',
      IssuUserId: (row) => Commons.EncryptAES(row.issuUserId ?? '') || '',
      Remark: (row) => Commons.EncryptAES(row.remark ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};
